<template>
    <div class="d-flex align-items-center mb-3">
        <div class="position-relative me-3">
            <div class="product-image-container">
                <img :src="DBitems.product.image" :alt="DBitems.product.name" class="product-image order_item_image">
            </div>
            <div class="badge-custom">{{ (item.quantity) }}</div>
        </div>
        <div class="flex-grow-1">
            <div class="product-title item_order_cart_name">{{ DBitems.product.name }}</div>
            <div class="product-subtitle">
                <div v-if="DBitems.final_options.length != 0">
                    <p v-for="(item, index) in DBitems.final_options" :key="index">
                        {{ item.option }} : {{ item.value }}
                    </p>
                </div>
                <div v-if="DBitems.checkbox_options.length != 0">
                    <p v-for="(item, index) in DBitems.checkbox_options" :key="index">
                        {{ item }}
                    </p>
                </div>
            </div>
        </div>
       <div class="price " v-if="item.offer_price != 0">{{ ((item.offer_price) * $store.state.rate).toFixed($store.state.digit_price) }}
      {{ $store.state.UnitPrice }}</div>
    <div class="price" v-else>

      {{ ((item.total_price) * $store.state.rate).toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}
    </div>
    </div>
</template>

<script>
export default {
    props: {
        itemId: String
    },
    data: function () {
        return {
            loading: false,
            DBitems: null,
            item: null,
            show: false
        };
    },
    created() {
        this.loading = true;
        this.item = this.$cookies.get(this.itemId);
        if (this.item != null) {
            //console.log(this.item)
            this.axios
                .post(
                    this.$store.state.base_api_url + this.$store.storeName + "/cart_item",
                    {
                        product_id: this.item.product_id,
                        final_option: this.item.final_option,
                        option_check: this.item.option_check
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data;
                    /*if (this.sections.size > 7) {
                    if (document.documentElement.getAttribute("dir") === "rtl") {
                      this.sections = this.sections.slice().reverse();
                    }
                  }*/
                })
                .then(() => (this.loading = false));
        }
    },
    methods: {
    }
};
</script>